export const SLIDE_HEIGHT_PX = 150;
export const MAX_FEEDS = 5;

export interface MediaItem {
  url?: string;
  thumbnailUrl?: string;
  aspectRatio?: string;
  type?: string;
}

export interface MediaLanguageJson {
  [language: string]: MediaItem[];
}

export interface FeedItem {
  objectId?: string;
  type?: string;
  mediaLanguageJson?: MediaLanguageJson;
}

export interface ExploreSlide {
  objectId: string;
  type: string;
  imageUrl: string;
  aspectRatio: string;
  slideWidth: number;
}
